import React, { useEffect, useState } from 'react';
import { OFF_SEASON_LABELS } from '../../constants/positions';
import { VIDEO_CONTENT_TYPES } from '../../constants/videoContentTypes';

/*
 * The per-clip details the athlete sets on their Videos page (VideoSlot in
 * pages/VideosPage.js), for the admin panel: type/label, content type, context,
 * clip tag, and — on combine clips — location and date.
 *
 * Each field saves alone on blur through PATCH /videos/:id (`onPatch`), and
 * only when it changed. The upsert the athlete page uses rewrites every field
 * of the row, so a stale copy of one field could undo an edit to another.
 */

const FIELDS_FROM = (v) => ({
  label: v.label || '',
  content_type: v.content_type || '',
  context_label: v.context_label || '',
  clip_tag: v.clip_tag || '',
  combine_location: v.combine_location || '',
  combine_date: v.combine_date || '',
});

const inputStyle = { width: 200, fontSize: 13 };

export default function AdminVideoDetails({ video, categoryLabel, onPatch }) {
  const [draft, setDraft] = useState(() => FIELDS_FROM(video));
  useEffect(() => { setDraft(FIELDS_FROM(video)); }, [video]);

  const saved = FIELDS_FROM(video);
  const name = `${categoryLabel} video ${video.slot_number || 1}`;
  const set = (key) => (e) => setDraft(d => ({ ...d, [key]: e.target.value }));
  const commit = (key) => () => {
    if (draft[key] === saved[key]) return;
    onPatch(video.id, { [key]: draft[key] });
  };
  const bind = (key) => ({ value: draft[key], onChange: set(key), onBlur: commit(key) });

  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', margin: '4px 0 10px' }} data-testid="admin_video_details">
      {video.category === 'off_season' ? (
        <select className="ae-field__input" style={inputStyle} aria-label={`${name} type`} {...bind('label')}>
          <option value="">Type…</option>
          {OFF_SEASON_LABELS.map(l => <option key={l} value={l}>{l}</option>)}
        </select>
      ) : (
        <input className="ae-field__input" style={inputStyle} placeholder="Label"
          aria-label={`${name} label`} {...bind('label')} />
      )}
      <select className="ae-field__input" style={inputStyle} aria-label={`${name} content type`} {...bind('content_type')}>
        <option value="">Content type…</option>
        {VIDEO_CONTENT_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
      </select>
      <input className="ae-field__input" style={inputStyle} placeholder="Context (e.g., Regional Final)"
        aria-label={`${name} context`} {...bind('context_label')} />
      <input className="ae-field__input" style={inputStyle} placeholder="Jersey #, role, or event"
        aria-label={`${name} clip tag`} {...bind('clip_tag')} />
      {video.category === 'combine' && (
        <>
          <input className="ae-field__input" style={inputStyle} placeholder="Location"
            aria-label={`${name} location`} {...bind('combine_location')} />
          <input className="ae-field__input" style={inputStyle} type="date"
            aria-label={`${name} date`} {...bind('combine_date')} />
        </>
      )}
    </div>
  );
}
